































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import {
  ActiveSurveyForm,
  SatisfactionSurveyActiveForm,
  StaffSurveyOverview,
  StaffSurveyCategory,
  StaffSurveyFormResponse,
} from "@/api";
import { dateFormat } from "@/common/date_format";
import Loading from "@/components/loader/loading.vue";
import OverviewCard from "@/components/card/OverviewCard.vue";
import StartSurvey from "./StartSurvey.vue";
import { getDayEndISO, getDayStartISO } from "@/tool/beginAtEndAt";
import SendSurveyLinkForm from "./SendSurveyCodeForm.vue";
import _ from "lodash";
import * as validation from "@/tool/validation";

@Component({
  components: {
    Loading,
    OverviewCard,
    StartSurvey,
    SendSurveyLinkForm,
  },
})
export default class StaffOverview extends Vue {
  loading = false;
  linkDialog = false;
  counter = 0;
  startDate = moment()
    .startOf("month")
    .format("YYYY-MM-DD");
  endDate = moment()
    .endOf("month")
    .format("YYYY-MM-DD");
  formErrors = "";
  showStartDate = false;
  showEndDate = false;
  filtering = false;
  dispatchType = "staff-orientation";
  currentTab = "staff-orientation";
  dischargeForm!: ActiveSurveyForm;
  admissionForm!: ActiveSurveyForm;
  satisfactionForm!: SatisfactionSurveyActiveForm;
  staffSurveyDialog = false;
  name = "";
  creating = false;
  rules = [validation.requiredString, validation.noSpace];
  // types = ["staff-orientation", "staff-satisfaction", "staff-exit"];

  created() {
    const dispatchType = this.$route.query.dispatchType;
    if (dispatchType) {
      this.dispatchType = dispatchType.toString() || "staff-exit";
    }
    this.setfilterDate();
    this.fetchSurveyData(true);
  }

  async fetchSurveyData(created = false) {
    const start = getDayStartISO(this.startDate);
    const end = getDayEndISO(this.endDate);
    // const payload = this.getPayload();
    const activeForm = this.$store.dispatch(
      "staffSurvey/getActiveStaffSurveyForm",
      this.dispatchType,
    );
    const overview = this.$store.dispatch(
      "staffSurvey/getStaffSurveyOverviews",
      { slug: this.dispatchType, beginAt: start, endAt: end },
    );
    if (created) {
      this.loading = true;
      await Promise.all([activeForm, overview]);
      this.loading = false;
    } else {
      this.filtering = true;
      await Promise.all([activeForm, overview]);
      this.filtering = false;
    }
  }

  get staffSurveyCategories() {
    const list = this.$store.getters["staffSurvey/categories"] as Array<
      StaffSurveyCategory
    >;
    return _.map(list, item => item.slug);
  }

  get formattedStartDate() {
    if (this.startDate) {
      return dateFormat(this.startDate);
    }
    return "";
  }
  get formattedEndDate() {
    if (this.endDate) {
      return dateFormat(this.endDate);
    }
    return "";
  }

  get overviewDetails() {
    const report = this.$store.getters[
      "staffSurvey/overviewDetails"
    ] as StaffSurveyOverview;
    return report;
  }

  get activeForm() {
    return (
      (this.$store.getters[
        "staffSurvey/activeForm"
      ] as StaffSurveyFormResponse) || null
    );
  }

  setfilterDate() {
    const beginAt = this.$store.getters["staffSurvey/beginAt"];
    const endAt = this.$store.getters["staffSurvey/endAt"];
    if (endAt && beginAt) {
      this.startDate = beginAt;
      this.endDate = endAt;
    } else {
      this.startDate = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      this.endDate = moment()
        .endOf("month")
        .format("YYYY-MM-DD");
    }
    if (this.startDate) this.formatDate(true);
    if (this.endDate) this.formatDate(false);
  }

  formatDate(isStartDate: boolean) {
    if (isStartDate) {
      this.$store.dispatch("staffSurvey/setBeginAt", this.startDate);
    } else {
      this.$store.dispatch("staffSurvey/setEndAt", this.endDate);
    }
  }

  async selectedDate() {
    if (this.startDate && this.endDate) {
      // const payload = this.getPayload();

      if (this.startDate < this.endDate) {
        const start = getDayStartISO(this.startDate);
        const end = getDayEndISO(this.endDate);
        this.formErrors = "";
        this.filtering = true;
        await this.$store.dispatch("staffSurvey/getStaffSurveyOverviews", {
          slug: this.dispatchType,
          beginAt: start,
          endAt: end,
        });
        this.filtering = false;
      } else {
        this.formErrors = "start date should not be greater than end date";
      }
    }
  }

  getPayload() {
    return {
      beginAt: this.startDate,
      endAt: this.endDate,
      dispatchType: this.dispatchType,
    };
  }

  async clearFilter() {
    this.startDate = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.endDate = moment()
      .endOf("month")
      .format("YYYY-MM-DD");
    this.formErrors = "";
    this.filtering = true;
    this.$store.dispatch("staffSurvey/setBeginAt");
    this.$store.dispatch("staffSurvey/setEndAt");
    await this.fetchSurveyData();
    this.filtering = false;
  }

  goTo(title: string, overviewId?: string) {
    this.$router.push({
      path: `/staff-survey/overview/details`,
      query: {
        dispatchType: this.dispatchType,
        beginAt: this.startDate,
        endAt: this.endDate,
        title,
        overviewId,
      },
    });
  }

  destroyed() {
    if (!this.$route.path.includes("overview")) {
      this.$store.dispatch("staffSurvey/setBeginAt");
      this.$store.dispatch("staffSurvey/setEndAt");
    }
  }

  complete(dispatch: string) {
    this.dispatchType = dispatch;
    this.clearFilter();
  }

  createSurveyForm() {
    let to = "";
    if (this.dispatchType === "staff-orientation") {
      to = "orientation";
    } else if (this.dispatchType === "staff-satisfaction") {
      to = "satisfaction";
    } else if (this.dispatchType === "staff-exit") {
      to = "exit";
    } else {
      to = this.dispatchType;
    }
    this.$router.push({
      path: `/staff-survey/${to}/form`,
    });
  }

  updateDispatchType(type: string) {
    this.dispatchType = type;
    this.clearFilter();
  }

  createCustomSurvey() {
    this.creating = true;
    const payload = {
      name: this.name,
    } as StaffSurveyCategory;
    this.$store
      .dispatch("staffSurvey/createStaffSurveyCategory", {
        requestBody: payload,
      })
      .then(() => {
        this.creating = false;
        this.staffSurveyDialog = false;
        this.name = "";
        this.fetchSurveyData();
      })
      .catch(() => {
        this.creating = false;
      });
  }
}
